import { inject, Service } from "@angular/core";

import { KpiChallenge, KpiSuccessStory, MainResponseModel } from "../models";
import { MainService } from "./main-service";

@Service()
export class NationalTargetCardApiService {
  private _mainService = inject(MainService);

  public getChallenge(kpiId: number, periodId: number) {
    const url = `national-target-card/getChallenge?kpiId=${kpiId}&periodId=${periodId}`;

    return this._mainService.sendRequest<MainResponseModel<KpiChallenge>>({
      method: "GET",
      url,
    });
  }

  public getSuccessStory(kpiId: number, periodId: number) {
    const url = `national-target-card/getSuccessStory?kpiId=${kpiId}&periodId=${periodId}`;

    return this._mainService.sendRequest<MainResponseModel<KpiSuccessStory>>({
      method: "GET",
      url,
    });
  }

  public saveChallenge(data: KpiChallenge, isUpdate: boolean) {
    const url = isUpdate ? `national-target-card/updateChallenge` : `national-target-card/createChallenge`;

    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url,
      data: data,
    });
  }

  public saveSuccessStory(data: KpiSuccessStory, isUpdate: boolean) {
    const url = isUpdate ? `national-target-card/updateSuccessStory` : `national-target-card/createSuccessStory`;

    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url,
      data: data,
    });
  }
}
